var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "knowledgePoints" },
    [
      _c(
        "el-button",
        {
          staticStyle: { width: "100%" },
          attrs: {
            size: "small",
            type: "primary",
            icon: "el-icon-star-off",
            plain: ""
          },
          on: {
            click: function($event) {
              return _vm.handleNodeClick({ id: "" })
            }
          }
        },
        [_vm._v("全部")]
      ),
      _vm._v(" "),
      _c("el-tree", {
        attrs: {
          data: _vm.knowledgePoints,
          "node-key": "id",
          "default-expand-all": "",
          props: _vm.defaultProps,
          draggable: "",
          "expand-on-click-node": false
        },
        on: { "node-click": _vm.handleNodeClick },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var node = ref.node
              var data = ref.data
              return _c(
                "span",
                {
                  staticClass: "custom-tree-node",
                  attrs: { title: node.label }
                },
                [_vm._v("\n        " + _vm._s(node.label) + "\n      ")]
              )
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02c3ad90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02c3ad90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/single_resource_course/components/knowledgePoints.vue
// module id = null
// module chunks = 